import styled, { css } from "styled-components";

export const Sentry = styled.div`
  position: relative;
  height: 0px;
  width: 100%;
`;

export const StickyBar = styled.header<{ $stuck: boolean }>`
  position: sticky;
  top: 0;
  z-index: 50;

  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 56px;
  padding: 0 20px;

  background: #fff;

  ${({ $stuck }) =>
    $stuck
      ? css`
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: saturate(120%) blur(6px);
          box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);
          border-bottom: 1px solid rgba(148, 163, 184, 0.25);
        `
      : css`
          background: #fff;
          box-shadow: none;
          border-bottom: 1px solid transparent;
        `}
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 800;
`;
